import Axios from "axios"


export async function event_load(v) {
    try {
        const branchInfo = window.EventManager.branchInfo
        const Set_eventList = window.EventManager.Set_eventList

        const result = await Axios
                        .post('/event/load', {
                            'branch_id': branchInfo['id'],
                            'search_word': v ? v : ''
                        })
        const data = result['data']

        if(data) {
            await Set_eventList(data)
        }

        return true
    }
    catch(error) {
        return false
    }
}


export async function status_load(props) {
    const branchInfo = window.EventManager.branchInfo
    const selectEevent = window.EventManager.selectEevent
    const Set_statusList = window.EventManager.Set_statusList

    const branch_id = branchInfo['id']
    const event_id = selectEevent['id']

    const search_day = props['search_day']
    const search_word = props['search_word']
    const page_setup = props['page_setup']

    const result = await Axios
                    .post('/status/load', {
                        'branch_id': branch_id,
                        'event_id': event_id,
                        'search_day': search_day,
                        'search_word': search_word,
                        'page_setup': page_setup,
                    })
    const data = result['data']

    if(data['status'] === 'fail') {
        alert(data['message'])
    }
    else if(data['status'] === 'success') {
        await Set_statusList(data['data'])
    }

    return true
}


export async function schedule_load() {
    const branchInfo = window.EventManager.branchInfo
    const selectEevent = window.EventManager.selectEevent
    const firstDay = window.EventManager.firstDay
    const lastDay = window.EventManager.lastDay
    const Set_monthSchedule = window.EventManager.Set_monthSchedule

    const branch_id = branchInfo['id']
    const event_id = selectEevent['id']

    const result = await Axios
                    .post('/schedule/load', {
                        'branch_id': branch_id,
                        'event_id': event_id,
                        'first_day': firstDay,
                        'last_day': lastDay
                    })

    await Set_monthSchedule(result['data'])
}


export async function status_info(props) {
    const user_id = props['user_id']

    const result = await Axios
                    .post('/status/info', {
                        user_id: user_id
                    })
    const data = result['data']

    if(data['status'] === 'fail') {
        alert(data['message'])
    }
    else if(data['status'] === 'success') {
        return data['data']
    }
}


export async function student_save(props) {
    const status = document.getElementById('status')
    const list = status.querySelectorAll('[name="student_one"]:checked')

    if(list.length === 0) {
        alert('신청자를 선택해 주세요.')
    }
    else if(window.confirm('입학희망생으로 등록하시겠습니까?')) {
        const consumer_list = []

        for(let i=0; i<list.length; i++) {
            consumer_list.push(list[i].value)
        }

        const result = await Axios
                        .post('/status/student/save', {
                            consumer_list: consumer_list
                        })
        const data = result['data']

        alert(data['message'])
        if(data['status'] === 'success') {
        }
    }
}


export async function apply_cancel(props) {
    const consumer_id = props['consumer_id']
    if(window.confirm('신청을 취소하시겠습니까?')) {
        const result = await Axios
                        .post('/status/cancel', {
                            consumer_id: consumer_id
                        })
        const data = result['data']

        alert(data['message'])
        if(data['status'] === 'success') {
            return true
        }
    }

    return false
}


export async function apply_remove(props) {
    const consumer_id = props['consumer_id']
    if(window.confirm('삭제하면 복구할 수 없습니다.\n그래도 신청을 삭제하시겠습니까?')) {
        const result = await Axios
                        .post('/status/remove', {
                            consumer_id: consumer_id
                        })
        const data = result['data']

        alert(data['message'])
        if(data['status'] === 'success') {
            return true
        }
    }

    return false
}